import { useLanguage } from "@/i18n/LanguageContext";

export function Marquee() {
  const { t } = useLanguage();
  const items = [...t.marquee, ...t.marquee];

  return (
    <div
      className="overflow-hidden border-y border-border bg-white py-5"
      data-testid="services-marquee"
      aria-hidden="true"
    >
      <div className="animate-marquee flex w-max items-center">
        {items.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="whitespace-nowrap px-8 font-display text-sm font-medium uppercase tracking-[0.2em] text-navy/70">
              {item}
            </span>
            <span className="h-1.5 w-1.5 rotate-45 bg-brand" />
          </span>
        ))}
      </div>
    </div>
  );
}
